module.exports = __webpack_public_path__ + "img/left.b3d7efae.png";